import { useMemo, useEffect } from "react";

import { useParams } from "react-router";

import { PageName } from "analytics/events";
import { useAppLanguageStore } from "app/stores/useAppLanguageStore";
import { useChecksRedirect } from "flows/Inventory/shared/hooks/useChecksRedirect";
import { serializeAndTranslateCheck } from "flows/Inventory/shared/models/check/serializer";
import { useGetCheckByIdQuery } from "flows/Inventory/shared/queries/check/check.generated";
import { useAnalytics } from "shared/hooks/useAnalytics";

export function useIDCData() {
  const appLanguage = useAppLanguageStore((state) => state.appLanguage);
  const { checkId } = useParams<{ checkId?: string }>();
  const { navigateToOrigin } = useChecksRedirect();
  const { sendSegmentTrackEvent } = useAnalytics();

  useEffect(() => {
    if (!checkId) {
      navigateToOrigin(PageName.INVENTORY_INBOUND_DEVIATION_CHECK_LIST_PAGE);
    }
  }, [checkId, navigateToOrigin]);

  const { data: taskData, loading: isLoading } = useGetCheckByIdQuery({
    variables: { checkId: checkId ?? "", isAlwaysInbound: true },
    skip: !checkId,
  });

  const serializedData = useMemo(() => {
    if (!taskData?.getTaskById?.task) return null;
    return serializeAndTranslateCheck(taskData.getTaskById.task, appLanguage);
  }, [taskData, appLanguage]);

  useEffect(() => {
    if (serializedData && serializedData.sku && checkId) {
      sendSegmentTrackEvent("stockCheckStarted", {
        type: "automated",
        check_id: checkId,
        product_sku: serializedData.sku,
        origin: PageName.INVENTORY_INBOUND_DEVIATION_CHECK_LIST_PAGE,
      });
    }
  }, [serializedData, checkId, sendSegmentTrackEvent]);

  return {
    IDCData: serializedData,
    customAttributes: taskData?.getTaskById?.task?.customAttributes ?? null,
    isLoading,
  };
}
